var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyTransaction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 102,
    viewBox: "0 0 221 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.95395,
    cy: 51.7542,
    r: 8.75145,
    fill: "#F1F1F1",
    stroke: "black",
    strokeWidth: 0.646219
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.66064,
    y: 6.38281,
    width: 160.317,
    height: 18.1491,
    rx: 7.75463,
    fill: "#F1F1F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59.8638,
    y: 42.6797,
    width: 160.317,
    height: 18.1491,
    rx: 7.75463,
    fill: "#F1F1F1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.6152,
    y: 79.7344,
    width: 110.407,
    height: 18.1491,
    rx: 7.75463,
    fill: "#F1F1F1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.82284,
    y: 23.1293,
    width: 96.369,
    height: 63.0957,
    rx: 4.20043,
    transform: "rotate(-12.9733 5.82284 23.1293)",
    fill: "#F3F3F3",
    stroke: "#999999",
    strokeWidth: 1.93866
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 57.0523,
    y: 37.5982,
    width: 96.369,
    height: 63.0957,
    rx: 4.20043,
    fill: "#F3F3F3",
    stroke: "#999999",
    strokeWidth: 1.93866
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3516,
    y: 54.0234,
    width: 93.7704,
    height: 13.6118,
    fill: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3516 54.0234H93.8936M97.2965 54.0234H105.993M109.396 54.0234H144.182M151.744 67.6353H126.789M118.092 67.6353H74.9882",
    stroke: "#999999",
    strokeWidth: 1.93866,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 174.052,
    cy: 88.8089,
    r: 8.75145,
    fill: "#F1F1F1",
    stroke: "black",
    strokeWidth: 0.646219
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.202,
    cy: 15.4574,
    r: 9.07456,
    fill: "#F1F1F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTransaction);
export default __webpack_public_path__ + "static/media/emptyTransaction.c52d8b16fbc420cec7623d66bbec3ad1.svg";
export { ForwardRef as ReactComponent };